import { useLingui } from "@lingui/react";

import { getApiErrorMessage } from "./getApiErrorMessage";

// Текст ошибки запроса или мутации для показа в компоненте; `null` — ошибки нет.
// Перерисовывается при смене языка.
export const useApiErrorMessage = (error: unknown): string | null => {
  const { i18n } = useLingui();
  return error === null || error === undefined ? null : getApiErrorMessage(error, i18n);
};
